import { render } from "./instructor-referral.vue?vue&type=template&id=08ed9b23"
import script from "./instructor-referral.vue?vue&type=script&lang=js"
export * from "./instructor-referral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__